"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcedureStack = exports.ProcedureRegistry = void 0;
exports.plink = plink;
exports.pcall = pcall;
exports.ppush = ppush;
exports.ppushflt = ppushflt;
exports.ppushy = ppushy;
exports.ppushBinary = ppushBinary;
exports.ppop = ppop;
exports.ppopflt = ppopflt;
exports.ppopy = ppopy;
exports.ppopBinary = ppopBinary;
exports.ppopString = ppopString;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
const register_values_1 = require("./register-values");
class ProcedureRegistry {
    handlers = new Map();
    link(id, handler) {
        this.handlers.set(id, handler);
    }
    call(id, args) {
        const handler = this.handlers.get(id);
        if (!handler) {
            throw new ediabasx_core_1.EdiabasError(ediabasx_core_1.EdiabasErrorCodes.UNKNOWN, `Procedure ${id} is not linked`);
        }
        return handler(args);
    }
}
exports.ProcedureRegistry = ProcedureRegistry;
class ProcedureStack {
    args = [];
    pushInt(value) {
        this.args.push({ kind: "int", value });
    }
    pushFloat(value) {
        this.args.push({ kind: "float", value });
    }
    pushBinary(value) {
        this.args.push({ kind: "binary", value: new Uint8Array(value) });
    }
    popInt() {
        const entry = this.args.pop();
        if (!entry || entry.kind !== "int") {
            return 0;
        }
        return entry.value;
    }
    popFloat() {
        const entry = this.args.pop();
        if (!entry || entry.kind !== "float") {
            return 0.0;
        }
        return entry.value;
    }
    popBinary() {
        const entry = this.args.pop();
        if (!entry || entry.kind !== "binary") {
            return new Uint8Array();
        }
        return new Uint8Array(entry.value);
    }
    drain() {
        const snapshot = this.args.splice(0, this.args.length);
        return snapshot.map((entry) => entry.kind === "binary"
            ? { kind: entry.kind, value: new Uint8Array(entry.value) }
            : entry);
    }
    size() {
        return this.args.length;
    }
}
exports.ProcedureStack = ProcedureStack;
function plink(registry, id, handler) {
    registry.link(id, handler);
}
function pcall(registry, stack, id) {
    const args = stack.drain();
    return registry.call(id, args);
}
function ppush(registers, stack, source) {
    stack.pushInt((0, register_values_1.getIntValue)(registers, source));
}
function ppushflt(registers, stack, source) {
    stack.pushFloat((0, register_values_1.getFloatValue)(registers, source));
}
function ppushy(registers, stack, source) {
    const value = (0, register_values_1.getStringValue)(registers, source);
    const encoded = (0, ediabasx_core_1.utf8ToCp1252)(value);
    stack.pushBinary(encoded);
}
function ppushBinary(stack, value) {
    stack.pushBinary(value);
}
function ppop(registers, stack, destination) {
    const value = stack.popInt();
    (0, register_values_1.setIntValue)(registers, destination, value);
}
function ppopflt(registers, stack, destination) {
    const value = stack.popFloat();
    (0, register_values_1.setFloatValue)(registers, destination, value);
}
function ppopy(registers, stack, destination) {
    const binary = stack.popBinary();
    const value = (0, ediabasx_core_1.cp1252ToUtf8)(binary);
    (0, register_values_1.setStringValue)(registers, destination, value);
}
function ppopBinary(stack) {
    const args = stack.drain();
    const entry = args.find((item) => item.kind === "binary");
    if (!entry || entry.kind !== "binary") {
        return new Uint8Array();
    }
    return new Uint8Array(entry.value);
}
function ppopString(stack) {
    const binary = ppopBinary(stack);
    return (0, ediabasx_core_1.cp1252ToUtf8)(binary);
}
//# sourceMappingURL=procedures.js.map